import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M19.8 9.6H4.2v6.6c0 .86 0 1.433.037 1.873.035.426.096.62.16.744a1.8 1.8 0 0 0 .786.787c.123.063.318.124.744.16.44.035 1.013.036 1.873.036h8.4c.86 0 1.433 0 1.873-.037.426-.035.62-.096.744-.16a1.8 1.8 0 0 0 .787-.786c.063-.123.124-.318.16-.744.035-.44.036-1.013.036-1.873V9.6Zm0-1.2H4.2v-.6c0-.86 0-1.433.037-1.873.035-.426.096-.62.16-.744a1.8 1.8 0 0 1 .786-.787c.123-.063.318-.124.744-.16C6.367 4.202 6.94 4.2 7.8 4.2h8.4c.86 0 1.433 0 1.873.037.426.035.62.096.744.16a1.8 1.8 0 0 1 .787.786c.063.123.124.318.16.744.035.44.036 1.013.036 1.873v.6Zm1.2-.6c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8Z"
      clip-rule="evenodd"
    />
  </svg>
`;
